import { WebView } from 'react-native-webview';

export const TermsAndPrivacy = () => (
  <WebView source={{ uri: 'https://ouitherapeutics.com/terms-and-privacy/' }} />
);
